/**
 * HeritageWood - Product Card Image Carousel
 * Permite navigarea prin imaginile produsului direct de pe card
 */
(function () {
  'use strict';

  function initCarousel(wrapper) {
    const images = wrapper.querySelectorAll('.hw-product-card__image');
    const dots = wrapper.querySelectorAll('.hw-carousel-dot');
    const prevBtn = wrapper.querySelector('.hw-carousel-prev');
    const nextBtn = wrapper.querySelector('.hw-carousel-next');
    
    if (!images.length || images.length < 2) return;
    
    let currentIndex = 0;
    const maxIndex = images.length - 1;
    
    function showImage(index) {
      images.forEach((img, i) => {
        img.classList.toggle('hw-carousel-active', i === index);
        img.style.display = '';
      });
      
      // Update dots
      dots.forEach((dot, i) => {
        dot.classList.toggle('active', i === index);
      });
      
      // Update buttons
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index === maxIndex;
    }
    
    function goToPrev(e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex > 0) {
        currentIndex--;
        showImage(currentIndex);
      }
    }
    
    function goToNext(e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex < maxIndex) {
        currentIndex++;
        showImage(currentIndex);
      }
    }
    
    function goToIndex(index, e) {
      e.preventDefault();
      e.stopPropagation();
      currentIndex = index;
      showImage(currentIndex);
    }
    
    // Event listeners
    if (prevBtn) prevBtn.addEventListener('click', goToPrev);
    if (nextBtn) nextBtn.addEventListener('click', goToNext);
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', (e) => goToIndex(index, e));
    });
    
    // Initial state
    showImage(0);
  }
  
  function initAllCarousels() {
    document.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }
  
  // Re-initialize on dynamic content (filters, pagination, etc.)
  document.addEventListener('hw:products-loaded', initAllCarousels);
  
  // Observer for dynamically added cards
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            if (node.hasAttribute('data-product-carousel')) {
              initCarousel(node);
            } else {
              node.querySelectorAll('[data-product-carousel]').forEach(initCarousel);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
